import { CommonModule } from "@angular/common";
import { Component } from "@angular/core";

@Component({
    selector: "grainger-form-page-wrapper",
    standalone: true,
    imports: [CommonModule],
    templateUrl: "./form-page-wrapper.component.html",
    styleUrl: "./form-page-wrapper.component.scss"
})
export class FormPageWrapperComponent {}
